import { HOTEL_LIST, HotelBaseType } from "@elit-hair/elitklinik-shared";
import { TbBuildingSkyscraper } from "react-icons/tb";

import { CommonStatusItem } from "@/types/global";

import { softColors } from "./colors";

export type HotelItem = CommonStatusItem & {
    label: string;
    value: HotelBaseType["name"];
};

export type HotelList = HotelItem[];

export const hotelItems: HotelList = HOTEL_LIST.map(({ name }, index) => {
    const color = Object.values(softColors)[index];
    return {
        label: name,
        value: name,
        component: () => TbBuildingSkyscraper,
        ...(color || softColors.gray),
        tooltip: {
            title: "Yolcu Oteli",
            description: name,
        },
    };
});
